export const STEP_BETWEEN_VALUES = 5;
